import { render, staticRenderFns } from "./NotificationMenuItem.vue?vue&type=template&id=e61df21e&scoped=true&"
import script from "./NotificationMenuItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationMenuItem.vue?vue&type=style&index=0&id=e61df21e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61df21e",
  null
  
)

export default component.exports